import Cookies from "js-cookie";
import { decryptData } from "utils/crypto";

export const taskSteps = () => {
  const roleId = Number(decryptData(Cookies.get("role_id")));
  const isAdmin = roleId === 1 || roleId === 2;

  const steps = [
    {
      target: '[data-tour="project-header"]',
      title: 'Project Directory',
      content:
        'This page displays all your projects. From here, you can manage projects, monitor their status, and access project details.',
      disableBeacon: true,
    },

    {
      target: '[data-tour="project-search"]',
      title: 'Search & Filter',
      content:
        'Quickly search for projects and control how many projects are displayed per page.',
    },
  ];

  // Only Admin & Super Admin
  if (isAdmin) {
    steps.push(
      {
        target: '[data-tour="try-demo-btn"]',
        title: 'Try Demo',
        content:
          'Launch a demo project to explore NUBAXPULSE features without affecting your actual projects.',
      },
      {
        target: '[data-tour="create-project-btn"]',
        title: 'Create Project',
        content:
          'Create a new project, configure its details, and start planning your team work.',
      }
    );
  }

  steps.push(
    {
      target: '[data-tour="project-table"]',
      title: 'Project Directory',
      content:
        'View all projects along with their project key, description, status, URLs, creation date, and other information.',
    },
    {
      target: '[data-tour="project-actions"]',
      title: 'Project Actions',
      content:
        'Use the Actions menu to edit project settings, manage members, or perform other available operations.',
    }
  );

  return steps;
};